import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/ui/Header";
import Footer from "../../components/ui/Footer";
import Icon from "../../components/AppIcon";

const eventsData = {
    2012: [{ name: "CAPACITACION OSIPTEL", folder: "OSIPTEL" }],
    2013: [
        { name: "EMPRESA MCS CONSULTORIA Y MONITOREO AMBIENTAL", folder: "MCS" },
        { name: "CAPACITACIÓN EMPRESA PUBLICOM", folder: "PUBLICOM" },
    ],
    2016: [
        { name: "COACHING CUERPO DIPLOMÁTICO BOGOTA", folder: "BOGOTA" },
        { name: "SIESUA – CAPACITACIÓN DE EMPRESAS", folder: "SIESUA" },
    ],
    2017: [
        { name: "CAPACITACIÓN EN EMPRESA EN SANTO DOMINGO", folder: "SD" },
        { name: "CAPACITACIÓN DE LIDERAZGO HOSPITAL DEL NIÑO SAN BORJA", folder: "SANBORJA" },
        { name: "CAPACITACIÓN DE MORFOPSICOLOGIA EN PUNTA DEL ESTE", folder: "PUNTA" },
        { name: "CAPACITACIÓN EMPRESA FIRASA", folder: "FIRASA" },
    ],
    2019: [
        { name: "DIPLOMADO DE MORFOPSICOLOGÍA", folder: "MORFO" },
        { name: "RUBRO NAVIERO", folder: "NAVIERA" },
    ],
    2020: [
        { name: "LECTURA DE ROSTRO PARA RRHH Y EMOCIONES EN MÉXICO", folder: "MEXICO" },
    ],
    2023: [
        { name: "TALLER RENACER MILÁN", folder: "RENACER" },
        { name: "CLASE TAROT ANGÉLICO ASTRAL ZÉFIRO", folder: "ZEFIRO" },
        { name: "CAPACITACIÓN HOTEL BOLIVAR", folder: "BOLIVAR" },
    ],
    2024: [
        { name: "CURSO ASTROLOGÍA FINANCIERA", folder: "ASTRO1" },
        { name: "ASTROLOGÍA FINANCIERA MILÁN", folder: "ASTRO2" },
    ],
};

const Photos = () => {
    const [selectedYear, setSelectedYear] = useState(null);
    const [yearImages, setYearImages] = useState({});

    // 🔥 Cargar imágenes por evento
    const loadImages = async (year, folder) => {
        const loadedImages = [];

        for (let i = 1; i <= 100; i++) {
            const fileName = String(i).padStart(3, "0") + ".webp";
            const path = `/assets/images/${year}/${folder}/${fileName}`;

            const exists = await new Promise((resolve) => {
                const img = new Image();
                img.src = path;
                img.onload = () => resolve(true);
                img.onerror = () => resolve(false);
            });

            if (!exists) break;

            loadedImages.push(path);
        }

        return loadedImages;
    };

    // 🔥 Cuando cambia el año → carga TODOS los eventos
    useEffect(() => {
        const loadYear = async () => {
            if (!selectedYear) return;

            const data = {};

            for (const event of eventsData[selectedYear]) {
                const imgs = await loadImages(selectedYear, event.folder);
                data[event.name] = imgs;
            }

            setYearImages(data);
        };

        loadYear();
    }, [selectedYear]);

    return (
        <div className="min-h-screen flex flex-col">
            <Header />

            <main className="flex-1 max-w-5xl mx-auto px-4 py-12">

                {/* Volver */}
                <div className="mb-8">
                    <Link to="/" className="inline-flex items-center text-primary hover:text-accent">
                        <Icon name="ArrowLeft" size={16} className="mr-2" />
                        Volver al inicio
                    </Link>
                </div>

                {/* Título */}
                <section className="text-center mb-10">
                    <h1 className="text-3xl font-bold text-primary">
                        Fotos
                    </h1>
                    <p className="font-bold text-primary mt-2">
                        Selecciona el año para visualizar las fotos
                    </p>
                </section>

                {/* 🔥 Cards de años (TAMAÑO FIJO) */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
                    {Object.keys(eventsData).map((year) => (
                        <div
                            key={year}
                            onClick={() => setSelectedYear(year)}
                            className={`cursor-pointer rounded-xl shadow flex items-center justify-center h-24
                                ${selectedYear === year
                                ? "bg-primary text-white shadow-lg scale-105"
                                : "bg-gray-100 hover:bg-gray-200"
                            }
                            `}
                        >
                            <h2 className="text-xl font-semibold">{year}</h2>
                        </div>
                    ))}
                </div>

                {/* 🔥 Render eventos + fotos */}
                {selectedYear && (
                    <div className="space-y-10">
                        {Object.entries(yearImages).map(([eventName, imgs], i) => (
                            <div key={i}>
                                <h2 className="text-xl font-bold mb-4">
                                    {eventName}
                                </h2>

                                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                    {imgs.map((src, index) => (
                                        <img
                                            key={index}
                                            src={src}
                                            alt="evento"
                                            className="rounded-lg"
                                        />
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                )}

            </main>

            <Footer />
        </div>
    );
};

export default Photos;